import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    modal: null,
    show: false,    // show modal
    logoutAlert: false
}
export const modalSlice = createSlice({
    name: 'modal',
    initialState: initialState,
    reducers: {
	setModal: (state, action) => {
      return {
        ...state,
        modal: action.payload
      }
	},
	reset: (state) => initialState,
    openModal: (state) => {
        return {
          ...state,
          show: true
        }
    },
    closeModal: (state) => {
        return {
          ...state,
          show: false
        }
    },
    setLogoutAlert: (state, action) => {
        return {
          ...state,
          logoutAlert: action.payload,
        }
    },
    }
});

export const { setModal, resetModal, closeModal, openModal, setLogoutAlert, reset } = modalSlice.actions;
export const selectModal = state => state.modal.modal;
export const selectLogoutAlert = state => state.modal.logoutAlert;
export const showModal = state => state.modal.show;
export default modalSlice.reducer;
